(() => {
  'use strict';

  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let motion = [];

  function cleanup() {
    observer?.disconnect();
    observer = null;
    motion.forEach(item => item.kill?.());
    motion = [];
  }

  function prepareMagicText(page) {
    const element = page.querySelector('[data-magic-text]');
    if (!element || element.dataset.magicReady) return element;
    const words = element.textContent.trim().split(/\s+/);
    element.textContent = '';
    words.forEach(word => {
      const wrapper = document.createElement('span');
      wrapper.className = 'about-magic-word';
      const ghost = document.createElement('span');
      ghost.className = 'about-magic-word__ghost';
      ghost.textContent = word;
      const ink = document.createElement('span');
      ink.className = 'about-magic-word__ink';
      ink.textContent = word;
      ink.setAttribute('aria-hidden', 'true');
      wrapper.append(ghost, ink);
      element.append(wrapper, document.createTextNode(' '));
    });
    element.dataset.magicReady = 'true';
    return element;
  }

  function setup() {
    cleanup();
    const page = document.querySelector('.information-page[data-page="about"]');
    if (!page || page.hidden) return;
    const magicText = prepareMagicText(page);

    const reveals = [...page.querySelectorAll('[data-about-reveal]')];
    if (reduce.matches) {
      reveals.forEach(item => item.classList.add('is-visible'));
      return;
    }

    page.classList.add('about-motion-ready');
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {rootMargin: '0px 0px -12% 0px', threshold: .12});
    reveals.forEach(item => observer.observe(item));

    requestAnimationFrame(() => page.querySelector('.about-hero-copy')?.classList.add('is-visible'));

    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    const hero = page.querySelector('.about-pro-hero');
    const mark = page.querySelector('.about-pro-mark');
    const lines = page.querySelectorAll('.about-hero-line');
    if (hero && mark) {
      const entrance = gsap.timeline({defaults:{ease:'power4.out'}})
        .fromTo(lines,{yPercent:24,opacity:0},{yPercent:0,opacity:1,duration:.8,stagger:.07},0)
        .fromTo(mark,{scale:.96,opacity:0},{scale:1,opacity:1,duration:.9},.12);
      motion.push(entrance);

      const drift = gsap.to(mark, {
        yPercent: -4,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top 80%',
          end: 'bottom top',
          scrub: .6,
          invalidateOnRefresh: true
        }
      });
      motion.push(drift, drift.scrollTrigger);
    }

    if (magicText) {
      const wordReveal = gsap.to(magicText.querySelectorAll('.about-magic-word__ink'), {
        opacity: 1,
        duration: .18,
        stagger: .12,
        ease: 'none',
        scrollTrigger: {
          trigger: magicText.closest('.about-pro-statement'),
          start: 'top 68%',
          end: 'bottom 88%',
          scrub: true
        }
      });
      motion.push(wordReveal, wordReveal.scrollTrigger);
    }
  }

  document.addEventListener('shrvy:page', event => {
    if (event.detail?.handle === 'about') requestAnimationFrame(setup);
    else cleanup();
  });
  document.addEventListener('shrvy:route', cleanup);
  reduce.addEventListener('change', setup);
  setup();
})();
